// extracted by mini-css-extract-plugin
module.exports = {"fixed":"ppBQL-"};